const ALBAY_CITIES = [
    '050515',
];
const ANTIQUE_CITIES = [
    '060605',
];
const BATANES_CITIES = [
    '020901',
    '020902',
    '020903',
    '020904',
    '020905',
    '020906',
];
const CAGAYAN_CITIES = [
    '021509',
];
const EASTERN_SAMAR_CITIES = [
    '082601',
];
const IFUGAO_CITIES = [
    '142706',
];
const ISABELA_CITIES = [
    '023110',
    '023111',
    '023117',
    '023121',
];
const KALINGA_CITIES = [
    '143201',
    '143206',
    '143208',
    '143215',
];
const MAGUINDANAO_CITIES = [
    '153820',
];
const MOUNTAIN_PROVINCE_CITIES = [
    '144401',
    '144405',
    '144406',
    '144408',
];
const NORTHERN_SAMAR_CITIES = [
    '084802',
    '084804',
    '084807',
    '084808',
    '084809',
    '084812',
    '084817',
    '084814',
];
const PALAWAN_CITIES = [
    '175302',
    '175303',
    '175304',
    '175308',
    '175322',
    '175310',
    '175311',
    '175313',
    '175321',
    '175314',
];
const ROMBLON_CITIES = [
    '175902',
    '175903',
    '175906',
    '175908',
    '175905',
    '175913',
    '175914',
];
const SOUTHERN_LEYTE_CITIES = [
    '086419',
];
const WESTERN_SAMAR_CITIES = [
    '086001',
    '086006',
    '086024',
    '086018',
    '086023',
];
export const JNTEXPRESS_PROHIBITED_CITIES = [
    ...ALBAY_CITIES,
    ...ANTIQUE_CITIES,
    ...BATANES_CITIES,
    ...CAGAYAN_CITIES,
    ...EASTERN_SAMAR_CITIES,
    ...IFUGAO_CITIES,
    ...ISABELA_CITIES,
    ...KALINGA_CITIES,
    ...MAGUINDANAO_CITIES,
    ...MOUNTAIN_PROVINCE_CITIES,
    ...NORTHERN_SAMAR_CITIES,
    ...PALAWAN_CITIES,
    ...ROMBLON_CITIES,
    ...SOUTHERN_LEYTE_CITIES,
    ...WESTERN_SAMAR_CITIES,
];
